import { memo } from 'react';
import { useSelector } from 'react-redux';
import useIsSmallViewport from 'hooks/useIsSmallViewport';

const SurfBanner = memo(({ className = '', showBanner, zoneId }) => {
  const IS_DEV = ['localhost', 'https://dev.lumedev.com'].includes(
    process.env.NEXT_PUBLIC_SITE_DOMAIN
  );

  const isSmallViewport = useIsSmallViewport();
  const storeSelection = useSelector((state) => state.storeSelection);

  const accountId = 'efaa6';
  const channelId = 'bf9bc';
  const height = '1';
  const locationId = IS_DEV ? 'surfsidetest' : storeSelection || 'all-stores';
  const siteId = '19f2e';
  const width = isSmallViewport ? '4' : '8';

  return (
    zoneId &&
    showBanner && (
      <div className={className}>
        <surf-banner
          channel-id={channelId}
          account-id={accountId}
          site-id={siteId}
          zone-id={zoneId}
          location-id={locationId}
          width={width}
          height={height}
        />
      </div>
    )
  );
});

export default SurfBanner;
